import jsPDF from 'jspdf'; // https://rawgit.com/MrRio/jsPDF/master/docs/index.html

import {getSelValueEsteso, getSelValueProvenienzaClienteEsteso} from '../Orders/UtilOrder.js';

export const PDFGenerator = (order) => {    
  let doc = new jsPDF();

  let sP = 25; // altezza di partenza del testo       
  const mL = 15; // margine sinistro   
  const PAGE_TITLE_FONT = 25;
  const SECTION_FONT = 15;    
  const TIMESTAMP_FONT = 8;

  let modCap = getSelValueEsteso(order['modalitaIncassoCaparra']);
  let numAut = order['NumeroAUT'];
  let trattenuta = (order['caparraTrattenuta'] == true? "trattenuta" : "non trattenuta");    
   
  // titolo 
  doc.setFontSize(PAGE_TITLE_FONT);          
  doc.text(mL, sP, 'Riepilogo');    
  doc.rect(mL, sP+3, 170, 0);  
  doc.setFontSize(TIMESTAMP_FONT);  
  doc.text(mL, sP+7, 'Ultima modifica: '+order['dataInsert']+', '+order['timeInsert'] + ' - pagina 1/2');

  // Prenotazione
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+15, 'Prenotazione');
  doc.setFontSize(12);    
  doc.text(mL, sP+22, 'Nr. prenotazione: '+order['nrPrenotazione']);
  doc.text(mL, sP+27, 'Nr. serata: '+order['nrSerata']);
  doc.text(mL, sP+32, 'Data serata: '+order['dataSerata']);         
  // Pagamento
  sP = sP + 32;
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+10, 'Pagamento');
  doc.setFontSize(12); 
  doc.text(mL, sP+17, 'Totale: '+order['totale']+' euro');  
  doc.text(mL, sP+22, 'Caparra: '+order['caparra'] + ' euro - ' + modCap + (numAut ? (" (num. aut. " + numAut + ")") : "") + ' - ' + trattenuta);
  doc.text(mL, sP+27, 'Rata alla consegna: '+order['importoPrimaRata']+' euro');  
  doc.text(mL, sP+32, 'Nr. rate: '+order['nrRate']+' rate');    
  doc.text(mL, sP+37, 'Mese posticipo: ' + (order['mesePosticipato']? order['mesePosticipato'] : '-'));  
  doc.text(mL, sP+42, 'Acconto posticipato: '+order['accontoPosticipato']+' euro');  
  doc.text(mL, sP+47, 'Acconto dimensione: '+order['accontoDimensione']+' euro');  
  doc.text(mL, sP+52, 'Importo singola rata: '+order['importoSingolaRata']+' euro');      
  // Indirizzo di consegna
  sP = sP+52;
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+10, 'Indirizzo di consegna');
  doc.setFontSize(12); 
  doc.text(mL, sP+17, 'Via: '+ ((order['via'])? order['via']:order['via2']) );
  doc.text(mL, sP+22, 'Cap: '+ ((order['cap'])? order['cap']:order['cap2']) );
  doc.text(mL, sP+27, 'Provincia: '+ ( (order['provincia'])? order['provincia']:order['provincia2']) );
  doc.text(mL, sP+32, 'Località: '+ ((order['localita'])? order['localita']:order['localita2']) );
  // Cliente
  sP = sP+32;      
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+10, 'Cliente');
  doc.setFontSize(12); 
  order['FlagClienteNuovo'] === "true" ? doc.text(mL, sP+17, 'Cliente nuovo') : doc.text(mL, sP+17, 'Già cliente (offerta famiglia)')
  doc.text(mL, sP+22, 'Provenienza cliente: '+ getSelValueProvenienzaClienteEsteso(order['ProvenienzaCliente']));
  doc.text(mL, sP+27, 'Nome: '+order['nome']);
  doc.text(mL, sP+32, 'Cognome: '+order['cognome']);
  doc.text(mL, sP+37, 'Codice fiscale: '+order['cf']);  
  doc.text(mL, sP+42, 'Partita iva: '+((order['iva'])?order['iva']:'-'));  
  doc.text(mL, sP+47, 'Telefono: '+(order['telefono']?order['telefono']:'-'));  
  doc.text(mL, sP+52, 'Cellulare: '+(order['cellulare']?order['cellulare']:'-'));  
  doc.text(mL, sP+57, 'Email: '+(order['email']?order['email']:'-'));  
  doc.text(mL, sP+62, 'Note di contatto: '+(order['noteContatti']?order['noteContatti']:'-'));  
  // Indirizzo del cliente
  sP = sP+62;
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+10, 'Indirizzo del cliente');
  doc.setFontSize(12); 
  doc.text(mL, sP+17, 'Via: '+order['via2']);
  doc.text(mL, sP+22, 'Cap: '+order['cap2']);
  doc.text(mL, sP+27, 'Provincia: '+order['provincia2']);
  doc.text(mL, sP+32, 'Località: '+order['localita2']);

  // SECONDA PAGINA
  doc.addPage();   
  sP = 25;  
  doc.setFontSize(PAGE_TITLE_FONT);          
  doc.text(mL, sP, 'Riepilogo');    
  doc.rect(mL, sP+3, 170, 0);  
  doc.setFontSize(TIMESTAMP_FONT);  
  doc.text(mL, sP+7, 'Ultima modifica: '+order['dataInsert']+', '+order['timeInsert']+' - pagina 2/2');

  // Prodotti    
  doc.setFontSize(SECTION_FONT);          
  doc.text(mL, sP+15, 'Prodotti');
  doc.setFontSize(12); 
  doc.text(mL, sP+22, 'Luce attuale: '+(order['luceAttuale']?order['luceAttuale']:'-'));
  doc.text(mL, sP+27, 'Rete attuale: '+(order['reteAttuale']?order['reteAttuale']:'-'));
  doc.text(mL, sP+32, 'Materasso attuale: '+(order['materassoAttuale']?order['materassoAttuale']:'-'));  
  doc.text(mL, sP+37, 'Altezza piedini: '+(order['numeroPiedini']?(order['numeroPiedini']+' cm'):'-'));  
  doc.text(mL, sP+42, 'Altezza fianchi: '+(order['numeroFianchi']?(order['numeroFianchi']+' cm'):'-'));  
  doc.text(mL, sP+47, 'Note prodotti: '+(order['noteAggiuntive']?order['noteAggiuntive']:'-'));  
  let pos=0;
  for(let key of Object.keys(order)) {      
    if(key === 'codArt_'+pos) {      
      doc.text(mL, sP+57+(25*pos), 'Codice articolo : '+order['codArt_'+pos]); 
      doc.text(mL, sP+62+(25*pos), 'Descrizione: '+order['descArt_'+pos]);      
      doc.text(mL, sP+67+(25*pos), 'Peso: '+order['pesoArt_'+pos]+' kg');            
      pos=pos+1;      
    }
  }
      
  // Salvataggio del documento    
  doc.save('ordine_'+ order['nrPrenotazione'] + '_' + Date.now() +'.pdf');    
}


// WEBPACK FOOTER //
// ./src/cmp/Summary/PDFGenerator.js